/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import * as zod from 'zod';


export const getTermsAcceptanceStatusResponse = zod.object({
  "status": zod.enum(['Required', 'Accepted']),
  "documentId": zod.string().uuid().nullish()
})

export const getTermsOfServiceResponse = zod.object({
  "documentId": zod.string().uuid(),
  "version": zod.number(),
  "effectiveDate": zod.string(),
  "content": zod.string()
})

export const acceptTermsOfServiceBody = zod.object({
  "legalDocumentId": zod.string().uuid()
})

